import React from 'react';
const Dislike = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={props.onClick}
    >
      <g id="Group 19817">
        <path
          id="Vector (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5496 18.2131C12.337 18.6916 11.8625 19 11.3388 19C9.9467 19 8.81818 17.8715 8.81818 16.4794L8.81818 13.9091L6.2704 13.9091C4.48751 13.9091 3.12402 12.3199 3.39515 10.5576L4.17835 5.46672C4.39672 4.04759 5.61777 3 7.05367 3L16.8182 3C18.0232 3 19 3.9768 19 5.18182L19 10.2727C19 11.4777 18.0232 12.4545 16.8182 12.4545L15.109 12.4545L12.5496 18.2131ZM13.9091 4.45455L7.05367 4.45454C6.33568 4.45454 5.72517 4.97833 5.61598 5.68792L4.83278 10.7788C4.69722 11.6599 5.37896 12.4545 6.2704 12.4545L8.81818 12.4545C9.62153 12.4545 10.2727 13.1058 10.2727 13.9091L10.2727 16.4794C10.2727 17.0403 10.7059 17.5001 11.256 17.5423L13.7798 11.8639C13.7798 11.8639 13.7798 11.8639 13.7798 11.8639C13.8162 11.782 13.8596 11.7046 13.9091 11.6323L13.9091 4.45455ZM15.3636 11L15.3636 4.45455L16.8182 4.45455C17.2199 4.45455 17.5455 4.78014 17.5455 5.18182L17.5455 10.2727C17.5455 10.6744 17.2199 11 16.8182 11L15.3636 11ZM11.2204 17.6224C11.2204 17.6223 11.2204 17.6225 11.2204 17.6224V17.6224Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default Dislike;
